"use strict";

globalThis.Hologram.pendingScripts ??= [];

globalThis.Hologram.pendingScripts.push({
  digest: new URL(document.currentScript.src).pathname.match(/-([^-]+)\.js$/)[1],
  define: (deps) => {
    const {
      Bitstring,
      ERTS,
      HologramBoxedError,
      HologramInterpreterError,
      Interpreter,
      MemoryStorage,
      Type,
      Utils,
    } = deps;

Interpreter.defineElixirFunction("Enumerable.Range", "slice", 1, "public", [{params: (context) => [Type.matchPattern(Type.map([[Type.atom("__struct__"), Type.atom("Elixir.Range")], [Type.atom("first"), Type.variablePattern("first_0")], [Type.atom("last"), Type.matchPlaceholder()], [Type.atom("step"), Type.variablePattern("step_2")]]), Type.variablePattern("range_3"))], guards: [], body: (context) => {
return Type.tuple([Type.atom("ok"), Elixir_Range["size/1"](context.vars.range_3), Type.anonymousFunction(3, [{params: (context) => [Type.variablePattern("$1"), Type.variablePattern("$2"), Type.variablePattern("$3")], guards: [], body: (context) => {
return Elixir_Enumerable_Range["slice/3"](Erlang["+/2"](context.vars.first_0, Erlang["*/2"](context.vars["$1"], context.vars.step_2)), Erlang["*/2"](context.vars.step_2, context.vars["$3"]), context.vars["$2"]);
}}], context, "-slice/1-fun-0-")]);
}}, {params: (context) => [Type.matchPattern(Type.map([[Type.atom("__struct__"), Type.atom("Elixir.Range")], [Type.atom("first"), Type.variablePattern("first_0")], [Type.atom("last"), Type.variablePattern("last_1")]]), Type.variablePattern("range_2"))], guards: [], body: (context) => {
Interpreter.matchOperator(Interpreter.case(Erlang["=</2"](context.vars.first_0, context.vars.last_1), [{match: Type.atom("false"), guards: [], body: (context) => {
return Type.integer(-1n);
}}, {match: Type.atom("true"), guards: [], body: (context) => {
return Type.integer(1n);
}}], context), Type.variablePattern("step_4"), context);
Interpreter.updateVarsToMatchedValues(context);
return Elixir_Enumerable_Range["slice/1"](Elixir_Map["put/3"](context.vars.range_2, Type.atom("step"), context.vars.step_4));
}}]);

Interpreter.defineElixirFunction("Enumerable.Range", "slice", 3, "private", [{params: (context) => [Type.variablePattern("current_0"), Type.matchPlaceholder(), Type.integer(1n)], guards: [], body: (context) => {
return Type.list([context.vars.current_0]);
}}, {params: (context) => [Type.variablePattern("current_0"), Type.variablePattern("step_1"), Type.variablePattern("remaining_2")], guards: [(context) => Erlang[">/2"](context.vars.remaining_2, Type.integer(1n))], body: (context) => {
return Interpreter.consOperator(context.vars.current_0, Elixir_Enumerable_Range["slice/3"](Erlang["+/2"](context.vars.current_0, context.vars.step_1), context.vars.step_1, Erlang["-/2"](context.vars.remaining_2, Type.integer(1n))));
}}]);
  },
});

document.dispatchEvent(new CustomEvent("hologram:scriptLoaded"));